<template>
  <v-container :fluid="$vuetify.breakpoint.lgAndDown">
    <v-overlay :value="loading" absolute class="text-center">
      <v-progress-circular indeterminate size="64"> </v-progress-circular>
      <p class="mt-4">This may take at most 30 seconds to load.</p>
      <code>{{ count.toFixed(1) }}s</code>
    </v-overlay>
    <v-alert text type="info" class="rounded-xl">
      These insights include stats for all users across TPU.
    </v-alert>
    <v-row v-if="user.reports">
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Uploads last week</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">{{ user.uploadsCurrent }}</h1>
          <v-card-subtitle style="margin-top: -35px">
            <v-icon :color="differenceIcon(user.uploadsDifference).color">
              {{ differenceIcon(user.uploadsDifference).icon }}
            </v-icon>
            {{ user.uploadsDifference?.toString().replace("-", "") }}
          </v-card-subtitle>
          <v-card-subtitle style="margin-top: -25px">
            {{ user.uploadsLast }} week before
          </v-card-subtitle>
        </v-card>
        <v-card
          color="toolbar"
          class="rounded-xl text-center mt-4"
          v-if="false"
        >
          <v-toolbar color="toolbar">
            <v-toolbar-title>Absences last term</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">
            {{
              user.attendance.absenceData[$date().year()].data[user.quarter - 2]
                .termCount
            }}
          </h1>
          <v-card-subtitle style="margin-top: -35px">
            <v-icon
              :color="
                differenceIcon(
                  user.attendance.absenceData[$date().year()].data[
                    user.quarter - 2
                  ].termCount -
                    user.attendance.absenceData[$date().year()].data[
                      user.quarter - 3
                    ].termCount,
                  true
                ).color
              "
            >
              {{
                differenceIcon(
                  user.attendance.absenceData[$date().year()].data[
                    user.quarter - 2
                  ].termCount -
                    user.attendance.absenceData[$date().year()].data[
                      user.quarter - 3
                    ].termCount,
                  true
                ).icon
              }}
            </v-icon>
            {{
              (
                user.attendance.absenceData[$date().year()].data[
                  user.quarter - 2
                ].termCount -
                user.attendance.absenceData[$date().year()].data[
                  user.quarter - 3
                ].termCount
              )
                .toString()
                .replace("-", "")
            }}
          </v-card-subtitle>
          <v-card-subtitle style="margin-top: -25px">
            {{
              user.attendance.absenceData[$date().year()].data[user.quarter - 3]
                .termCount
            }}
            last term
          </v-card-subtitle>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Last week usage stats</v-toolbar-title>
          </v-toolbar>
          <ChartBar
            :chartData="usageHoursGraph"
            :chart-options="options"
            v-if="usageHoursGraph"
          ></ChartBar>
          <small class="grey--text">Higher is better?</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Collections per hour</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <h3>
              Everyone collectivizes the most at {{ collectionHours.hour }} with
              {{ collectionHours.count }} uploads!
            </h3>
            <ChartBar
              :chart-data="collectionHoursGraph"
              v-if="collectionHoursGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Usage per operating system</v-toolbar-title>
          </v-toolbar>
          <ChartBar
            :chartData="usagePlatformGraph"
            :chart-options="options"
            v-if="usagePlatformGraph"
          ></ChartBar>
          <small class="grey--text">Higher is better?</small>
        </v-card>
      </v-col>
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Uploads per weekday</v-toolbar-title>
          </v-toolbar>
          <ChartBar
            :chartData="weekdaysGraph"
            :chart-options="options"
            v-if="weekdaysGraph"
          ></ChartBar>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card
          color="toolbar"
          class="rounded-xl text-center mt-4"
          v-if="false"
        >
          <v-toolbar color="toolbar">
            <v-toolbar-title>All-Time Report Score</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">{{ user.school.score }}%</h1>
          <v-card-subtitle style="margin-top: -35px">
            <v-icon
              :color="
                differenceIcon(user.school.score - user.school.scoreLastCycle)
                  .color
              "
            >
              {{
                differenceIcon(user.school.score - user.school.scoreLastCycle)
                  .icon
              }}
            </v-icon>
            {{ user.school.score - user.school.scoreLastCycle }}
          </v-card-subtitle>
          <v-card-subtitle style="margin-top: -25px">
            {{ user.school.scoreLastCycle }}% last cycle
          </v-card-subtitle>
        </v-card>
        <v-card class="rounded-xl text-center mt-4" color="toolbar">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Current UploadStreak</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <h1 style="font-size: 130px">{{ user.streak }}</h1>
            <small class="grey--text">
              Streak Began: {{ user.streakBegan }}<br />
              <v-icon class="grey--text">mdi-chart-timeline-variant</v-icon
              >&nbsp;Highest Streak: {{ highestStreak }}<br />Total Streaks:
              {{ user.streaks.length }}</small
            >
          </v-container>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Uploads per year</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <ChartBar
              :chart-data="yearsGraph"
              v-if="yearsGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>AutoCollects per hour*</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <h3>
              Everyone AutoCollects the most at {{ autoCollectHours.hour }} with
              {{ autoCollectHours.count }} uploads!
            </h3>
            <ChartBar
              :chart-data="autoCollectHoursGraph"
              v-if="autoCollectHoursGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small><br />
          <small class="grey--text"
            >* Bulk actions are treated as a single AutoCollect. Includes
            accepts, and rejections.</small
          >
        </v-card>
      </v-col>
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center" v-if="false">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Weekdays</v-toolbar-title>
          </v-toolbar>
          <LineChart
            :chart-data="user.attendance.graph"
            :chart-options="options"
            :height="420"
          ></LineChart>
          <small class="grey--text">Lower is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Uploads per month</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="year"
              :items="years"
              label="Year"
              single-line
              hide-details
            ></v-select>
          </v-toolbar>
          <v-container>
            <ChartBar
              :chart-data="monthsGraph"
              v-if="monthsGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Uploads per hour</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <h3>
              Everyone uploads the most at {{ hoursMost.hour }} with
              {{ hoursMost.count }} uploads!
            </h3>
            <ChartBar
              :chart-data="hoursGraph"
              v-if="hoursGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Average TPU website usage per day</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <p class="mb-n5 grey--text">Everyone spends on average</p>
            <h1 style="font-size: 80px">{{ user.pulse.avgHours }}h</h1>
            <p class="mt-n5 grey--text">per day using TPU.</p>
          </v-container>
          <small class="grey--text">Higher is better?</small><br />
          <small class="grey--text"
            >* Usage history before 15/10/2022 will not be counted.</small
          >
        </v-card>
        <v-card
          color="toolbar"
          class="rounded-xl text-center mt-4"
          v-if="autoCollectAccuracy"
        >
          <v-toolbar color="toolbar">
            <v-toolbar-title>AutoCollect Accuracy</v-toolbar-title>
          </v-toolbar>
          <v-container>
            <h3>
              Out of {{ autoCollectAccuracy.total }} AutoCollects,
              {{ autoCollectAccuracy.correct }} were accepted and
              {{ autoCollectAccuracy.incorrect }} were rejected.
            </h3>
            <ChartBar
              :chart-data="autoCollectAccuracyGraph"
              v-if="autoCollectAccuracyGraph"
              :chart-options="options"
            ></ChartBar>
          </v-container>
          <small class="grey--text">Higher is better</small><br />
          <small class="grey--text"
            >* Bulk actions are treated as a single AutoCollect.</small
          >
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="!user.reports">
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Progress Reports</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">
            <v-skeleton-loader
              class="mx-auto mt-2 mb-2"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </h1>
          <br />
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Absences this term</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">
            <v-skeleton-loader
              class="mx-auto mt-2 mb-2"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </h1>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Top 100 words</v-toolbar-title>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span> The top 100 words contained within screenshots. </span>
            </v-tooltip>
          </v-toolbar>
          <h1 style="font-size: 5em">
            <v-skeleton-loader
              class="mx-auto mt-2 mb-2"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </h1>
        </v-card>
      </v-col>
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Progress Reports Over Time</v-toolbar-title>
          </v-toolbar>
          <v-skeleton-loader
            class="mx-auto mt-2 mb-2"
            max-width="300"
            type="card"
          ></v-skeleton-loader>
          <small class="grey--text">Higher is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>All-Time Report Score</v-toolbar-title>
          </v-toolbar>
          <h1 style="font-size: 5em">
            <v-skeleton-loader
              class="mx-auto mt-2 mb-2"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </h1>
        </v-card>
      </v-col>
      <v-col>
        <v-card color="toolbar" class="rounded-xl text-center">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Attendance Over Time</v-toolbar-title>
          </v-toolbar>
          <v-skeleton-loader
            class="mx-auto mt-2 mb-2"
            max-width="300"
            type="card"
          ></v-skeleton-loader>
          <small class="grey--text">Lower is better</small>
        </v-card>
        <v-card color="toolbar" class="rounded-xl text-center mt-4">
          <v-toolbar color="toolbar">
            <v-toolbar-title>Rank Neighbours</v-toolbar-title>
          </v-toolbar>
          <v-skeleton-loader
            class="mx-auto mt-2 mb-2"
            max-width="300"
            type="card"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

import ChartBar from "@/components/ChartBar"

export default {
  name: "InsightsStandalone",
  components: { ChartBar },
  props: ["id"],
  data() {
    return {
      user: {},
      loading: true,
      count: 0.0,
      year: "latest",
      wordHeaders: [
        {
          text: "Index",
          value: "index"
        },
        {
          text: "Word",
          value: "word"
        },
        { text: "Count", value: "count" }
      ],
      attendance: {
        weekdays: null,
        loading: true,
        streak: 0,
        highestStreak: 0
      },
      closeUserHeaders: [
        {
          text: "Rank",
          value: "rank"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Form Group",
          value: "form"
        },
        {
          text: "Student Code",
          value: "sussiId"
        },
        {
          text: "Score",
          value: "reportScore"
        }
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        }
      }
    }
  },
  computed: {
    usagePlatformGraph() {
      if (this.user.pulse.platforms) {
        return {
          labels: Object.keys(this.user.pulse.platforms),
          datasets: [
            {
              label: "Hours",
              data: Object.values(this.user.pulse.platforms),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    years() {
      let years = ["latest"]
      for (let i = 2021; i <= new Date().getFullYear(); i++) {
        years.push(i)
      }
      return years
    },
    usageHoursGraph() {
      if (this.user.pulse.hours) {
        return {
          labels: Object.keys(this.user.pulse.hours),
          datasets: [
            {
              label: "Hours",
              data: Object.values(this.user.pulse.hours),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    hoursGraph() {
      if (this.user.hours) {
        return {
          labels: Object.keys(this.user.hours),
          datasets: [
            {
              label: "Uploads",
              data: Object.values(this.user.hours),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    yearsGraph() {
      if (this.user.years) {
        return {
          labels: Object.keys(this.user.years),
          datasets: [
            {
              label: "Uploads",
              data: Object.values(this.user.years),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    autoCollectAccuracyGraph() {
      if (this.user.pulse.autoCollectRejections) {
        return {
          labels: ["Accepted", "Rejected"],
          datasets: [
            {
              label: "AutoCollects",
              data: [
                this.user.pulse.autoCollectAccepts,
                this.user.pulse.autoCollectRejections
              ],
              backgroundColor: ["#3f51b5", "#f44336"],
              borderColor: ["#3f51b5", "#f44336"],
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    autoCollectAccuracy() {
      if (this.user.pulse.autoCollectRejections) {
        return {
          percentage: Math.round(
            (this.user.pulse.autoCollectAccepts /
              (this.user.pulse.autoCollectAccepts +
                this.user.pulse.autoCollectRejections)) *
              100
          ),
          total:
            this.user.pulse.autoCollectAccepts +
            this.user.pulse.autoCollectRejections,
          correct: this.user.pulse.autoCollectAccepts,
          incorrect: this.user.pulse.autoCollectRejections
        }
      } else {
        return null
      }
    },
    hoursMost() {
      if (this.user.hours) {
        let hours = Object.entries(this.user.hours)
        hours.sort((a, b) => b[1] - a[1])
        return {
          hour: hours[0][0],
          count: hours[0][1]
        }
      } else {
        return null
      }
    },
    autoCollectHours() {
      if (this.user.pulse.autoCollectHours) {
        let hours = Object.entries(this.user.pulse.autoCollectHours)
        hours.sort((a, b) => b[1] - a[1])
        return {
          hour: hours[0][0],
          count: hours[0][1]
        }
      } else {
        return null
      }
    },
    collectionHours() {
      if (this.user.pulse.collectionHours) {
        let hours = Object.entries(this.user.pulse.collectionHours)
        hours.sort((a, b) => b[1] - a[1])
        return {
          hour: hours[0][0],
          count: hours[0][1]
        }
      } else {
        return null
      }
    },
    collectionHoursGraph() {
      if (this.user.hours) {
        return {
          labels: Object.keys(this.user.pulse.collectionHours),
          datasets: [
            {
              label: "Collectivized Uploads",
              data: Object.values(this.user.pulse.collectionHours),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    autoCollectHoursGraph() {
      if (this.user.hours) {
        return {
          labels: Object.keys(this.user.pulse.autoCollectHours),
          datasets: [
            {
              label: "AutoCollects",
              data: Object.values(this.user.pulse.autoCollectHours),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    weekdaysGraph() {
      if (this.user.weekdays) {
        return {
          labels: Object.keys(this.user.weekdays),
          datasets: [
            {
              label: "Uploads",
              data: Object.values(this.user.weekdays),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    monthsGraph() {
      if (this.user.months) {
        return {
          labels: Object.keys(this.user.months),
          datasets: [
            {
              label: "Uploads",
              data: Object.values(this.user.months),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    highestStreak() {
      if (!this.user?.streaks) return 0
      try {
        return this.user.streaks.reduce((a, b) => (a.count > b.count ? a : b))
          .count
      } catch {
        return this.user.streak
      }
    }
  },
  methods: {
    differenceIcon(diff, reverse = false) {
      if (!reverse) {
        if (diff > 0) {
          return {
            icon: "mdi-arrow-up-circle",
            color: "success"
          }
        } else if (diff < 0) {
          return {
            icon: "mdi-arrow-down-circle",
            color: "red"
          }
        } else {
          return {
            icon: "mdi-minus-circle",
            color: "warning"
          }
        }
      } else {
        if (diff > 0) {
          return {
            icon: "mdi-arrow-up-circle",
            color: "red"
          }
        } else if (diff < 0) {
          return {
            icon: "mdi-arrow-down-circle",
            color: "success"
          }
        } else {
          return {
            icon: "mdi-minus-circle",
            color: "warning"
          }
        }
      }
    },
    getInsights() {
      this.user = {}
      this.count = 0
      let countUp = setInterval(() => {
        this.count += 0.1
      }, 100)
      this.loading = true
      this.axios
        .get(
          "/api/v1/insights/global/" + this.year + "/" + this.id ||
            this.$store.state.user.userId
        )
        .then((res) => {
          this.user = res.data
          this.loading = false
          clearInterval(countUp)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
          clearInterval(countUp)
        })
    }
  },
  mounted() {
    this.getInsights()
  },
  watch: {
    year() {
      this.getInsights()
    }
  }
}
</script>

<style scoped></style>
